var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { selectPlayerProfilePictureName } from "../../../balancingSelectors/selectBalancingPictures";
import { IdStyles } from "../../../less/IdStyles";
import { selectCoopInfoViewId, selectCoopInfoViewMember, selectCoopMemberLastLoginClass, } from "../../../selectors/selectCoopInfo";
import { selectModalTabId } from "../../../selectors/selectModalTabId";
import { selectOwnPlayerId } from "../../../selectors/selectPlayerInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { utilLoca } from "../../../utils/i18n/utilLoca";
import { utilNumber } from "../../../utils/utilNumber";
import { ButtonSort } from "../../generic/common/ButtonSort";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { Table } from "../../generic/table/Table";
import { IdModal } from "../../modals/IdModal";
import { actionOpenOtherPlayerProfile, actionOpenOwnPlayerProfile, } from "../../player-profile/actionPlayerProfile";
import { IdCoopCategory } from "../IdCoopCategory";
import { mapCoopRole } from "../mapCoopRole";
import { CoopMemberTableRow } from "./CoopMemberTableRow";
import { IdCoopMemberSortBy } from "./IdCoopMemberSortBy";
import { IdCoopRole } from "./IdCoopRole";
var CoopMemberDOM = /** @class */ (function (_super) {
    __extends(CoopMemberDOM, _super);
    function CoopMemberDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { selectedSortBy: IdCoopMemberSortBy.Rank };
        _this.memberOnlineTab = {
            content: React.createElement(Icon, { icon: IdIcon.OnlineIcn, styleId: IdStyles.IconSmall }),
        };
        _this.notCoopMemberTableHeaders = [
            { content: utilLoca.get(IdLoca.coopRank), sortById: IdCoopMemberSortBy.Rank },
            { content: utilLoca.get(IdLoca.rankingMenu_name), sortById: IdCoopMemberSortBy.Name },
            {
                content: React.createElement(Icon, { icon: IdIcon.XpIcn, styleId: IdStyles.IconSmall }),
                sortById: IdCoopMemberSortBy.Xp,
            },
            {
                content: React.createElement(Icon, { icon: IdIcon.CoopFundsIcn, styleId: IdStyles.IconSmall }),
                sortById: IdCoopMemberSortBy.Funds,
            },
        ];
        _this.coopMemberTableHeaders = [
            _this.memberOnlineTab
        ].concat(_this.notCoopMemberTableHeaders);
        _this.getTableHeaders = function () {
            var headers = [];
            var selectedSortBy = _this.state.selectedSortBy;
            var tab = _this.props.tab;
            var tableHeaders = tab === IdCoopCategory.CoopInfoView
                ? _this.coopMemberTableHeaders
                : _this.notCoopMemberTableHeaders;
            tableHeaders.forEach(function (head, index) {
                var nameColClassName = head.content === utilLoca.get(IdLoca.rankingMenu_name) ? "td--pp" : "";
                var isSelected = head.sortById === selectedSortBy;
                headers.push(React.createElement(React.Fragment, { key: "th-" + index },
                    React.createElement("div", { className: "td info-view-sort-btn-member-col " + nameColClassName + " " + IdStyles.TextNormal },
                        head.content,
                        head.sortById && (React.createElement("div", { className: "info-view-sort-btn" },
                            React.createElement(ButtonSort, { onClick: function () { return _this.onSortBtnClick(head.sortById); }, className: isSelected ? "selected" : "", disabled: isSelected })))),
                    index + 1 < tableHeaders.length && React.createElement("div", { className: "td__divider" })));
            });
            return headers;
        };
        _this.getTableRows = function () {
            var rows = [];
            var _a = _this.props, playerId = _a.playerId, onSelfClick = _a.onSelfClick, onPlayerRowClick = _a.onPlayerRowClick;
            var sortedMembers = _this.sortMembers();
            var tab = _this.props.tab;
            sortedMembers.forEach(function (member) {
                var icon = (member.role
                    ? mapCoopRole.get(member.role)
                    : mapCoopRole.get(IdCoopRole.Leader)).icon;
                var profilePictureName = selectPlayerProfilePictureName(member.profilePictureId || 1);
                var activityClassName = selectCoopMemberLastLoginClass(member.loginTime);
                var onClick = member.playerId.equals(playerId)
                    ? onSelfClick
                    : function () { return onPlayerRowClick(member.playerId); };
                rows.push(React.createElement(CoopMemberTableRow, { tab: tab, onClick: onClick, member: member, memberActivityClassName: activityClassName, memberRoleIcon: icon, profilePicName: profilePictureName, key: utilNumber.format(member.playerId) }));
            });
            return rows;
        };
        _this.onSortBtnClick = function (id) {
            _this.setState({
                selectedSortBy: id,
            });
        };
        _this.sortMembers = function () {
            var member = _this.props.member;
            var selectedSortBy = _this.state.selectedSortBy;
            var sortedMembers = member.slice();
            switch (selectedSortBy) {
                case IdCoopMemberSortBy.Rank:
                    return sortedMembers.sort(function (a, b) {
                        var rankDifference = (a.role || 0) - (b.role || 0);
                        if (rankDifference === 0) {
                            return b.xp.compare(a.xp);
                        }
                        return rankDifference;
                    });
                case IdCoopMemberSortBy.Name:
                    return sortedMembers.sort(function (a, b) {
                        if (a.name < b.name) {
                            return -1;
                        }
                        if (a.name > b.name) {
                            return 1;
                        }
                        return 0;
                    });
                case IdCoopMemberSortBy.Xp:
                    return sortedMembers.sort(function (a, b) {
                        return b.xp.compare(a.xp);
                    });
                case IdCoopMemberSortBy.Funds:
                    return sortedMembers.sort(function (a, b) {
                        return (b.donation || Long.ZERO).compare(a.donation || Long.ZERO);
                    });
                default:
                    return sortedMembers;
            }
        };
        return _this;
    }
    CoopMemberDOM.prototype.render = function () {
        var headers = this.getTableHeaders();
        var rows = this.getTableRows();
        return (React.createElement("div", { className: "info-view-member-table" },
            React.createElement(Table, { headers: headers, rows: rows, tableContainerClassName: IdStyles.CoopInfoRankingContainer })));
    };
    return CoopMemberDOM;
}(React.Component));
var mapState = function (state) { return ({
    coopId: selectCoopInfoViewId(state),
    member: selectCoopInfoViewMember(state),
    playerId: selectOwnPlayerId(state),
    tab: selectModalTabId(state, IdModal.Coop),
}); };
var mapDispatch = function (dispatch) { return ({
    onPlayerRowClick: function (id) { return dispatch(actionOpenOtherPlayerProfile(id)); },
    onSelfClick: function () { return dispatch(actionOpenOwnPlayerProfile()); },
}); };
export var CoopMember = connect(mapState, mapDispatch)(CoopMemberDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/info-view/CoopMember.tsx
// module id = 918
// module chunks = 3